import React, { ReactNode } from 'react';
import Image from 'next/image';

interface ITwoColFullScreen {
  leftContent?: ReactNode;
  children?: ReactNode;
  mobileHeader?: ReactNode;
  head?: ReactNode;
}

const TwoColFullScreen = (props: ITwoColFullScreen) => {
  const { leftContent, children, mobileHeader, head } = props;
  return (
    <div className="flex h-full flex-col lg:flex-row">
      {head}
      <div
        className="relative hidden items-center pl-20 lg:flex"
        style={{ flexBasis: '46.389%' }}
      >
        {leftContent}

        <div className="fixed left-0 top-0 -z-2 h-full w-1/2">
          <div className="flex">
            <Image
              layout="fill"
              objectFit="cover"
              src="/assets/agreement-background.svg"
              alt="agreement image"
            />
          </div>
        </div>
      </div>
      <div className="flex lg:hidden ">{mobileHeader}</div>

      <div className="min-h-0 flex-auto bg-white lg:flex-1">{children}</div>
    </div>
  );
};

export default TwoColFullScreen;
